import List from "components/list";
import React from "react";
import { TypeCell } from "@/modules/reports/billables/extension/cells";
import { StatusCell } from "@/components/status/cell";
import ContractFilters from "./filters";

const customSearch = (search) => ({
  _or: [
    { name: { _icontains: search } },
    { project: { name: { _icontains: search } } },
  ],
});

export default function Contracts() {
  const fields = [
    "id",
    "name",
    "type",
    "status",
    "project.name",
    "jobs.id",
    "jobs.name",
    "project.project_id",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "project.name",
      header: "Project",
      accessorKey: "project.name",
    },
    {
      id: "jobs.id",
      header: "Jobs",
      accessorKey: "jobs",
      cell: ({ row }) => {
        const jobs = row.original.jobs;
        if (!jobs) return null;
        return jobs.length;
      },
    },
  ];

  return (
    <>
      <List
        title="Contracts"
        storageKey="contracts"
        endPoint="contracts"
        columns={columns}
        meta={{ fields, customSearch }}
        href={(item) =>
          `/work/contracts/${item.id}`
        }
        renderFilters={ContractFilters}
      />
    </>
  );
}
